<template>
  <div id="jumbotron">
    <div class="overlay"></div> <!-- Blue blur overlay -->
    <div class="container content">
      <p class="title">
        {{ $t('aboutPage.title') }}
      </p>
    </div>
  </div>

  <div class="container mt-5">

    <h1>{{ $t('aboutPage.about.title') }}</h1>
    <div v-html="$t('aboutPage.about.description')"></div>
    
    <div class="container py-5">
      <h2 class="text-center mb-4">
        {{ $t('aboutPage.leadership.title') }}
      </h2>
      <p>
        {{ $t('aboutPage.leadership.description') }}
      </p>
      <div class="row justify-content-center mt-5">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/Nas.webp" class="card-img-top" alt="Pricipal, Nasiha Nas">
            <div class="card-body text-center">
              <h5 class="card-title">Nasiha Nas</h5>
              <p class="card-subtitle">{{ $t('aboutPage.leadership.nasiha.title') }}</p>
              <p class="card-text">{{ $t('aboutPage.leadership.nasiha.description') }}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/matthew.jpg" class="card-img-top" alt="Group CEO, Matthew Gan">
            <div class="card-body text-center">
              <h5 class="card-title">Matthew Gan</h5>
              <p class="card-subtitle">{{ $t('aboutPage.leadership.matthew.title') }}</p>
              <p class="card-text">{{ $t('aboutPage.leadership.matthew.description') }}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/nicholas.jpg" class="card-img-top" alt="Centre Director, Nicolas Chan">
            <div class="card-body text-center">
              <h5 class="card-title">Nicolas Chan</h5>
              <p class="card-subtitle">{{ $t('aboutPage.leadership.nicholas.title') }}</p>
              <p class="card-text">{{ $t('aboutPage.leadership.nicholas.description') }}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/olivier.webp" class="card-img-top" alt="Professor Dr. Olivier Cane (Academic Advisor and French Principal)">
            <div class="card-body text-center">
              <h5 class="card-title">Professor Dr. Olivier Cane</h5>
              <p class="card-subtitle">{{ $t('aboutPage.leadership.oliver.title') }}</p>
              <p class="card-text">{{ $t('aboutPage.leadership.oliver.description') }}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/leon.enc" class="card-img-top" alt="Chief Technology Officer, Leon Lim">
            <div class="card-body text-center">
              <h5 class="card-title">Leon Lim</h5>
              <p class="card-subtitle">{{ $t('aboutPage.leadership.leon.title') }}</p>
              <p class="card-text">{{ $t('aboutPage.leadership.leon.description') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  #jumbotron {
    position: relative;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/banner-buiding.webp");
    background-size: cover;
    background-position: center;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Blue blurry overlay */
  #jumbotron .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 5, 115, 0.75); /* Blue tint */
  }

  #jumbotron .content {
    position: relative;
    z-index: 2;
  }

  #jumbotron .title {
    color: white;
    font-size: 5em;
    font-weight: bold;
  }

 .card {
    border: none;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
    margin-bottom: 2em;
  }
  .card:hover {
    transform: translateY(-5px);
  }
  .card img {
    width: 70%;
    height: auto;
    object-fit: cover;
    border-radius: 50%;
    margin: auto;
    margin-top: 1em;
    border: 4px solid white;
    display: block;
  }
  .card-title {
    font-size: 1.25rem;
    font-weight: bold;
  }
  .card-subtitle {
    font-size: 1rem;
    font-weight: bold;
    color: #FF4d37;
  }
  .card-text {
    color: #555;
  }
</style>